import axios from 'axios'
import Vue from 'vue'
const baseURL = process.env.VUE_APP_API_URL

const axiosIns = axios.create({
  baseURL,
  timeout: 60000,
  headers: { 'Access-Control-Allow-Origin': '*' },
})

// eslint-disable no-param-reassign
axiosIns.interceptors.request.use(
  config => {
    const authHeaders = $cookies.get('userAuth')

    if (authHeaders) {
      config.headers[config.method] = {
        'access-token': authHeaders['access-token'],
        client: authHeaders.client,
        uid: authHeaders.uid,
        expiry: authHeaders.expiry,
        'token-type': authHeaders['token-type'],
      }
    }

    return config
  },
  error => Promise.reject(error),
)

axiosIns.interceptors.response.use(
  response => {
    if (response.headers['access-token']) {
      const authHeaders = {
        'access-token': response.headers['access-token'],
        client: response.headers.client,
        uid: response.headers.uid,
        expiry: response.headers.expiry,
        'token-type': response.headers['token-type'],
      }
      $cookies.set('userAuth', authHeaders)
    }

    return response
  },
  error => Promise.reject(error),
)

Vue.prototype.$http = axiosIns

export {
  axiosIns as axios,
  baseURL,
}